import { render, staticRenderFns } from "./r-trigger-talk.vue?vue&type=template&id=91b70ba4&scoped=true"
import script from "./r-trigger-talk.vue?vue&type=script&lang=js"
export * from "./r-trigger-talk.vue?vue&type=script&lang=js"
import style0 from "./r-trigger-talk.vue?vue&type=style&index=0&id=91b70ba4&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b70ba4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91b70ba4')) {
      api.createRecord('91b70ba4', component.options)
    } else {
      api.reload('91b70ba4', component.options)
    }
    module.hot.accept("./r-trigger-talk.vue?vue&type=template&id=91b70ba4&scoped=true", function () {
      api.rerender('91b70ba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trigger/r-trigger-talk.vue"
export default component.exports